import React from 'react'
import CandidateTable from './CandidateTable.jsx'
import actions from '../utils/actions.js'

export default class CandidatePage extends React.Component {

  constructor (props) {
    super(props)
    this.state = {candidates: [], page: 1, max_pages: 0}
    this.fetchPage = this.fetchPage.bind(this)
    this.nextPage = this.nextPage.bind(this)
    this.previousPage = this.previousPage.bind(this)
  }

  componentWillMount () {
    this.fetchPage(0)
  }

  fetchPage (offset) {
    const { page } = this.state
    actions.getCandidates(page + offset, (err, res) => {
      if (err) { return window.alert('No se pudieron traer los candidatos :(') }
      this.setState({
        candidates: res.body.candidates,
        max_pages: res.body.max_pages,
        page: page + offset
      })
    })
  }

  nextPage () {
    this.fetchPage(1)
  }

  previousPage () {
    this.fetchPage(-1)
  }

  render () {
    const { candidates, page, max_pages } = this.state
    return (
      <div className="candidate-wrap">
        <h2>Listado</h2><a href="/app/candidates/csv/">Descargar Todo</a>
        <CandidateTable candidates={candidates} />
        <button
          disabled={page <= 1}
          className="button button--primary"
          onClick={this.previousPage}
        >
          Anterior
        </button>
        <button
          disabled={page >= max_pages}
          className="button button--primary"
          onClick={this.nextPage}
        >
          Siguiente
        </button>
      </div>
    )
  }
}
